import React from "react";
import { EnvContext } from "../../context/env-context";

class Picture extends React.Component {
  render() {
    const props = this.props;
    const src = props.src;
    let dimensions = props.options;


    return (
      <>
        <picture className={props.classNameOuter}>
          {props.sources &&
            Object.entries(props.sources).map(([media, source]) => {
              /*if (this.context === "staging") {
                source = source.replace(
                  "https://",
                  "https://staging:*Staging21%@"
                );
              }*/
              return (
                <source
                  key={"picture_" + source}
                  srcSet={source}
                  media={media}
                />
              );
            })}
          <img
            className={props.className}
            src={src}
            {...dimensions}
            alt={props.alt}
            loading="lazy"
          />
        </picture>
      </>
    );
  }
}
Picture.contextType = EnvContext;

export default Picture;
